import './ccf-logout-icon.module.scss';

import { SvgIcon , SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfLogoutIconProps  extends SvgIconProps {}
/**
 * component used to display logput icon in agent state panel
 * @param props - CcfLogoutIconProps
 * @example - <CcfLogoutIcon />
 * @returns SVG of logout icon
 */
export function CcfLogoutIcon(props: CcfLogoutIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_logout" clipPath="url(#clip-ic_logout)">
        <g id="exit-acw" transform="translate(4 4)">
          <path
            id="Path_25125"
            data-name="Path 25125"
            d="M162.476-81h10.449a1.049,1.049,0,0,1,1.07.889,1,1,0,0,1-1.012,1.094h-9.405a.42.42,0,0,0-.424.413V-67.4a.42.42,0,0,0,.424.413h9.347a1.049,1.049,0,0,1,1.07.889A1,1,0,0,1,172.983-65H162.476a1.339,1.339,0,0,1-1.356-1.322V-79.678A1.339,1.339,0,0,1,162.476-81Z"
            transform="translate(-161.12 81)"
            fill="#333"
          />
          <path
            id="Path_25126"
            data-name="Path 25126"
            d="M162.72-72.116v-1.622l-3.981,0A.753.753,0,0,1,158-74.5a.751.751,0,0,1,.739-.761h3.981v-1.624c0-.278.185-.382.412-.227l3.423,2.332a.315.315,0,0,1,0,.557l-3.421,2.337C162.907-71.731,162.72-71.836,162.72-72.116Z"
            transform="translate(-150.721 82.5)"
            fill="#333"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfLogoutIcon;
